import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class ProgramVehiclesByDistanceTableRowCtrl implements IController {

  tier: any;
  isEdit: boolean;
  isFirst:boolean;
  isLast: boolean;
  min: any;
  max: any;
  onUpdateTier: Function;
  onDelete: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.isLast || changes.min) {
      if (this.isLast) {
        this.distanceChanged(_.isNumber(this.min) ? this.min : 0, 'from')
      } else {
        _.unset(this.tier, 'extraChargePerMeter');
        this.updateRequired();
      }
    }
  };

  updateRequired() {
    this.onUpdateTier({tier: this.tier});
  }

  distanceChanged(value, path) {
    this.tier[path] = angular.copy(value);
    this.updateRequired();
  }

  extraChargeChanged(value){
    this.tier.extraChargePerMeter = value;
    this.updateRequired();
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programVehiclesByDistanceTableRow', {
    require: {
      form: '^form'
    },
    bindings: {
      index: '<',
      tier: '<',
      isEdit: '<?',
      isFirst: '<?',
      isLast: '<?',
      min: '<?',
      max: '<?',
      onUpdateTier: '&',
      onDelete: '&'
    },
    template: require('./program-vehicles-by-distance-table-row.html').default,
    controller: ProgramVehiclesByDistanceTableRowCtrl
  });
